/* import __COLOCATED_TEMPLATE__ from './text-overflow.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
